import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../Base/Services/ToastService";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";

import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";
import { obtenerSubCategoriasAct } from "../../../../../Base/API/Global/SubCategorias/SubCategoriasRequests";
import { addTipoProducto, ObtenerTipoProductosAct } from "../../../../../Base/API/Global/TipoProducto/TipoProductoRequest";
import { obtenerCategoriasAct } from "../../../../../Base/API/Global/Categorias/CategoriasRequests";

const TipoProductoCrudModal = ({
  TipoProducto,
  tipoProductoDialog,
  setTipoProductoDialog,
  toastRef,
  getTipoProducto,
  modo,
}) => {
  const toastDialog = useRef(null);
  const toast = useRef(null);

  const [show, setShow] = useState(false);

  const [estados, setEstados] = useState([{}]);
  const [categoria, setCategoria] = useState([{}]);
  const [subCategoria, setSubCategoria] = useState([{}]);
  const [tipoProductoList, setTipoProductoList] = useState([{}]);
  const [loading, setLoading] = useState(true);
  const { userAuth } = useContext(AuthContext);

  const initialValues = {
    IdTipoProducto: -1,
    IdSubCategoria: "",
    NombreTipoProducto: "",
    IdStatus: TipoProducto ? TipoProducto?.IdStatus : 5,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true)
    const categoriaActiva = await obtenerCategoriasAct();

    const estadosTempo = await getEstadosCategory("General");
    const subCategorias = await obtenerSubCategoriasAct();
    const tipoProducto = await ObtenerTipoProductosAct();
    setTipoProductoList(tipoProducto);

    setCategoria(categoriaActiva);
    setEstados(estadosTempo);
    setSubCategoria(subCategorias);

    // Si el modo es "Crear", establece el primer estado como valor inicial
    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === TipoProducto?.IdStatus);

    setValues({
      ...TipoProducto,
      Estado: estadoInicial, // Establece el estado inicial
      IdStatus: estadoInicial.IdStatus, // Establece el IdStatus en values

      SubCategoria: subCategorias.find(
        (s) => TipoProducto?.IdSubCategoria === s.IdSubCategoria
      ),
      Categoria: categoriaActiva.find(
        (c) => TipoProducto?.IdCategoria === c.IdCategoria
      ), // Asegúrate de que los nombres de las propiedades coincidan
    });
    setLoading(false)
  };

  const onHide = () => {
    setTipoProductoDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.NombreTipoProducto) {
      error.NombreTipoProducto = true;
      error.error = true;
    }
    if (!values.Categoria?.IdCategoria) {
      error.IdCategoria = true;
      error.error = true;
    }
    if (!values.SubCategoria?.IdSubCategoria) {
      error.IdSubCategoria = true;
      error.error = true;
    }
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdStatus = true;
      error.error = true;
    }
    setError(error);
    // console.log(error);
    return error;
  };

  const agregarTipoProducto = async () => {
    const e = verificarInfo();

    if (!e.error) {
      let estadoId = null;
      if (values.Estado) {
        estadoId = values.Estado.IdStatus;
      }
      const a = {
        IdTipoProducto: values?.IdTipoProducto,
        IdSubCategoria: values.SubCategoria.IdSubCategoria,
        NombreTipoProducto: values.NombreTipoProducto,
        IdStatus: estadoId,
        IdUserCreate: userAuth?.IdUser
      };
      const resultado = await addTipoProducto(a);
      toastShow(toastRef, "success", "Datos Agregados","Sub Categoría agregada correctamente");
      setTimeout(() => {
        onHide();
        getTipoProducto();
      }, 700);
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregarTipoProducto();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (tipoProductoDialog) {
      getValoresIniciales();
    }
  }, [tipoProductoDialog]);

  const dialogTitle =
    modo === "Crear" ? "Agregar Tipo de Producto" : "Modificar Tipo de Producto";

  return (
    <div>
      <Toast ref={toast} style={{ zIndex: 50000 }} />
      <ConfirmDialog />
      <Dialog
        visible={tipoProductoDialog}
        modal
        className="modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="Dialogg">
        <Loader loading={loading} querySelector={"#Dialogg"} />
        <div style={{ width: "100", margin: "auto" }}>
          <div className="d-flex align-items-center">
            <h2 className="me-3">{dialogTitle}</h2>
          </div>
          <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Categoria"}
                  value={values.Categoria}
                  items={categoria}
                  field={"NombreCategoria"}
                  label={"Categoría"}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.IdCategoria ? "p-invalid" : ""}
                  handleInputChange={(e) => {
                    handleInputChange(e);
                    setValues((prevValues) => ({
                      ...prevValues,
                      SubCategoria: null,
                    }));
                  }}
                />
              </span>
            </div>

            <div className="field col-6 me-2 mt-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"SubCategoria"}
                  value={values.SubCategoria}
                  items={subCategoria}
                  field={"NombreSubcategoria"}
                  label={"SubCategorías"}
                  handleInputChange={handleInputChange}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.IdSubCategoria ? "p-invalid" : ""}
                  filterValue={values?.Categoria}
                  itemsFilter={(e) => {
                    let filtro = subCategoria.filter(
                      (s) =>
                        s.IdCategoria === values?.Categoria?.IdCategoria
                    );
                    let filtro2 = values?.Categoria?.IdCategoria;
                    if (filtro.length === 0 && filtro2) {
                      toastShow(
                        toast,
                        "warn",
                        "Seleccione otro Tipo Producto",
                        "El tipo Producto seleccionado no cuenta con categorías disponibles"
                      );
                    }
                    return filtro;
                  }}
                />
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="NombreTipoProducto"
                  value={values.NombreTipoProducto}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.NombreTipoProducto ? "p-invalid" : ""}
                />
                <label htmlFor="NombreProducto">Tipo de Producto</label>
              </span>
            </div>
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Estado"}
                  value={values.Estado}
                  items={estados}
                  field={"StatusName"}
                  label={"Estado"}
                  handleInputChange={handleInputChange}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.IdStatus ? "p-invalid" : ""}
                />

              </span>
            </div>
          </div>
        </div>

        </div>
      </Dialog>
    </div>
  );
};

export default TipoProductoCrudModal;
